import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
          <path d="M15,15.5 L8,15.5 M11.5,7 L11.5,13.4 M8.3,10.2 L11.5,13.4 L14.7,10.2"/>
          <circle cx="11.5" cy="11.5" r="11"/>
        </g>
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M17,30.5 L30,30.5 M23.5,16 L23.5,27 M27.9,22.6 L23.5,27 L19.1,22.6"/>
        <circle cx="23.5" cy="23.5" r="22"/>
      </g>
    </svg>
  );
};
